import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import * as fromStore from '../store';
import { select, Store } from '@ngrx/store';

@Component({
  selector: 'app-credit-report-reasons',
  templateUrl: './credit-report-reasons.component.html'
})
export class CreditReportReasonsComponent {
  reasonsForm: FormGroup;
  reasonsFiledownloadState$: Observable<fromStore.ReasonsReportState>;

  constructor(private _store: Store<fromStore.CreditReportDetailsState>, private fb: FormBuilder) {
    this.reasonsForm = this.fb.group({
      fromDate: [new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().slice(0, 16), Validators.required], // last 7 days
      toDate: [new Date().toISOString().slice(0, 16), Validators.required]
    });
  }

  ngOnInit() {
    this.reasonsFiledownloadState$ = this._store.pipe(select(fromStore.getCreditReportReasonsState));
  }

  onSubmit() {
    if (this.reasonsForm.valid) {
      this.downloadCreditReportReasons(this.reasonsForm.value.fromDate, this.reasonsForm.value.toDate);
    }
  }

  downloadCreditReportReasons(startDate, endDate) {
    this._store.dispatch(new fromStore.DownloadReasonsReport({ startDate, endDate }));
  }
}
